(function () {
  'use strict';

  const UPSELL_LIMIT = 3;
  const TIMER_MINUTES = 10;
  const TIMER_KEY = 'franka_cart_timer_end';

  let lastProductId = null;
  let cachedProducts = null;
  let timerInterval = null;
  let isRefreshing = false;
  let debounceTimer = null;

  const styles = [
    '.franka-cart-upsell { padding: 16px 16px 8px; border-top: 1px solid #e8e2d9; }',
    '.franka-cart-upsell__title { font-size: 11px; font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase; color: #888780; margin: 0 0 12px; }',
    '.franka-cart-upsell__grid { display: flex; flex-direction: column; gap: 10px; padding-bottom: 8px; }',
    '.franka-upsell-card { width: 100%; border: 1px solid #e8e2d9; border-radius: 6px; overflow: hidden; background: #fff; transition: border-color 0.2s; display: flex; flex-direction: row; }',
    '.franka-upsell-card:hover { border-color: #3d3d3a; }',
    '.franka-upsell-card__img { width: 80px; height: 100px; object-fit: cover; display: block; flex-shrink: 0; }',
    '.franka-upsell-card__img-placeholder { width: 80px; height: 100px; background: #f0ede8; flex-shrink: 0; }',
    '.franka-upsell-card__body { padding: 8px; display: flex; flex-direction: column; flex: 1; justify-content: center; }',
    '.franka-upsell-card__name { font-size: 11px; font-weight: 500; color: #3d3d3a; line-height: 1.3; margin: 0 0 3px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }',
    '.franka-upsell-card__price { font-size: 11px; color: #888780; margin: 0 0 7px; }',
    '.franka-upsell-card__btn { width: 100%; padding: 5px 4px; font-size: 11px; font-weight: 500; border: 1px solid #3d3d3a; border-radius: 4px; background: #fff; color: #3d3d3a; cursor: pointer; transition: background 0.15s, color 0.15s; margin-top: auto; }',
    '.franka-upsell-card__btn:hover { background: #3d3d3a; color: #fff; }',
    '.franka-upsell-card__btn--added { background: #2d6a4f; border-color: #2d6a4f; color: #fff; pointer-events: none; }',
    '.franka-upsell-card__btn--loading { opacity: 0.6; pointer-events: none; }'
  ].join(' ');

  function injectStyles() {
    if (document.getElementById('franka-cart-styles')) return;
    const tag = document.createElement('style');
    tag.id = 'franka-cart-styles';
    tag.textContent = styles;
    document.head.appendChild(tag);
  }

  function formatPrice(cents) {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency', currency: 'CLP', maximumFractionDigits: 0
    }).format(Math.round(cents / 100));
  }

  /* ── Timer ─────────────────────────────────────────────────────── */
  function renderTimer() {
    if (document.getElementById('franka-cart-timer')) return;
    const subtotal = document.querySelector('.cart-totals__container');
    if (!subtotal) return;
    const el = document.createElement('div');
    el.id = 'franka-cart-timer';
    el.className = 'franka-cart-timer';
    el.innerHTML = '<span class="franka-cart-timer__icon">&#x26A0;&#xFE0F;</span><span class="franka-cart-timer__text">Su pedido est&#xE1; reservado por <strong id="franka-timer-display">10:00</strong></span>';
    subtotal.after(el);
  }

  function tickTimer() {
    const display = document.getElementById('franka-timer-display');
    const container = document.getElementById('franka-cart-timer');
    if (!display || !container) return;
    let endTime = parseInt(sessionStorage.getItem(TIMER_KEY) || '0');
    if (!endTime || endTime < Date.now()) {
      endTime = Date.now() + TIMER_MINUTES * 60 * 1000;
      sessionStorage.setItem(TIMER_KEY, String(endTime));
    }
    const remaining = Math.max(0, endTime - Date.now());
    const mins = Math.floor(remaining / 60000);
    const secs = Math.floor((remaining % 60000) / 1000);
    const mStr = mins < 10 ? '0' + mins : '' + mins;
    const sStr = secs < 10 ? '0' + secs : '' + secs;
    display.textContent = mStr + ':' + sStr;
    if (remaining < 60000) {
      container.classList.add('franka-cart-timer--urgent');
    } else {
      container.classList.remove('franka-cart-timer--urgent');
    }
    if (remaining <= 0) {
      endTime = Date.now() + TIMER_MINUTES * 60 * 1000;
      sessionStorage.setItem(TIMER_KEY, String(endTime));
    }
  }

  function startTimer() {
    renderTimer();
    tickTimer();
    if (timerInterval) clearInterval(timerInterval);
    timerInterval = setInterval(tickTimer, 1000);
  }
  /* ── Fin timer ─────────────────────────────────────────────────── */

  function renderUpsellCard(product) {
    const variant = product.variants[0];
    const imgTag = product.featured_image
      ? '<img class="franka-upsell-card__img" src="' + product.featured_image + '" alt="' + product.title + '" loading="lazy">'
      : '<div class="franka-upsell-card__img-placeholder"></div>';
    return '<div class="franka-upsell-card" data-variant-id="' + variant.id + '">' +
      '<a href="/products/' + product.handle + '" style="text-decoration:none">' + imgTag + '</a>' +
      '<div class="franka-upsell-card__body">' +
      '<p class="franka-upsell-card__name">' + product.title + '</p>' +
      '<p class="franka-upsell-card__price">' + formatPrice(variant.price) + '</p>' +
      '<button class="franka-upsell-card__btn" data-variant-id="' + variant.id + '">+ Agregar</button>' +
      '</div></div>';
  }

  function bindUpsellButtons() {
    document.querySelectorAll('.franka-upsell-card__btn').forEach(function(btn) {
      btn.addEventListener('click', function () {
        addToCart(this.dataset.variantId, this);
      });
    });
  }

  function injectUpsellsIntoDOM(products) {
    document.querySelectorAll('#franka-cart-upsell').forEach(function(el) { el.remove(); });
    const form = document.getElementById('cart-form');
    if (!form) return;
    const wrapper = document.createElement('div');
    wrapper.id = 'franka-cart-upsell';
    wrapper.className = 'franka-cart-upsell';
    let cards = '';
    products.forEach(function(p) { cards += renderUpsellCard(p); });
    wrapper.innerHTML = '<p class="franka-cart-upsell__title">Completa tu look</p><div class="franka-cart-upsell__grid">' + cards + '</div>';
    form.after(wrapper);
    bindUpsellButtons();
  }

  function showUpsells() {
    if (!lastProductId) return;
    if (cachedProducts) {
      injectUpsellsIntoDOM(cachedProducts);
      return;
    }
    fetch('/recommendations/products.json?product_id=' + lastProductId + '&limit=' + UPSELL_LIMIT + '&intent=related')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        const products = (data.products || []).filter(function(p) { return p.available; });
        if (products.length) {
          cachedProducts = products;
          injectUpsellsIntoDOM(products);
        }
      });
  }

  function getSectionId() {
    const cartComponent = document.querySelector('cart-items-component[data-drawer]');
    return cartComponent && cartComponent.dataset ? cartComponent.dataset.sectionId || null : null;
  }

  function refreshDrawer() {
    if (isRefreshing) return;
    isRefreshing = true;
    const sectionId = getSectionId();
    if (!sectionId) { isRefreshing = false; return; }
    fetch('/?sections=' + sectionId)
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        const html = sections[sectionId];
        if (!html) return;
        const event = new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { sections: { [sectionId]: html } } }
        });
        document.dispatchEvent(event);
      })
      .catch(function() {})
      .finally(function() { isRefreshing = false; });
  }

  function addToCart(variantId, btn) {
    btn.classList.add('franka-upsell-card__btn--loading');
    btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.classList.remove('franka-upsell-card__btn--loading');
        btn.classList.add('franka-upsell-card__btn--added');
        btn.textContent = '\u2713 Agregado';
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        if (cart.items && cart.items.length > 0) lastProductId = cart.items[0].product_id;
        cachedProducts = null;
        refreshDrawer();
      })
      .catch(function() {
        btn.classList.remove('franka-upsell-card__btn--loading');
        btn.textContent = '+ Agregar';
      });
  }

  function init() {
    injectStyles();

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.items && cart.items.length > 0) {
          lastProductId = cart.items[0].product_id;
        }
      });

    setTimeout(startTimer, 600);

    const observer = new MutationObserver(function(mutations) {
      let relevant = false;
      for (let i = 0; i < mutations.length; i++) {
        const m = mutations[i];
        if (m.addedNodes.length > 0) {
          for (let j = 0; j < m.addedNodes.length; j++) {
            const n = m.addedNodes[j];
            if (n.id !== 'franka-cart-upsell' && n.id !== 'franka-cart-timer' && n.id !== 'franka-cart-styles') {
              relevant = true;
              break;
            }
          }
        }
        if (relevant) break;
      }
      if (!relevant) return;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        const form = document.getElementById('cart-form');
        const upsells = document.getElementById('franka-cart-upsell');

        if (form && !upsells) {
          if (lastProductId) {
            showUpsells();
          } else {
            fetch('/cart.js')
              .then(function(r) { return r.json(); })
              .then(function(cart) {
                if (cart.items && cart.items.length > 0) {
                  lastProductId = cart.items[0].product_id;
                  showUpsells();
                }
              });
          }
        }

        if (!document.getElementById('franka-cart-timer') && document.querySelector('.cart-totals__container')) {
          renderTimer();
        }
      }, 300);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();